// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
/* You must import the icons you want bundled with the app. They must be added to the 'library' */
import { faSearch, faExternalLinkAlt, faSync, faInfoCircle, faSpinner, faQuestionCircle }
  from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueGtag from 'vue-gtag';
import App from './App';
import router from './router';
import titleMixin from './util/titleMixin';
import { store } from './store/store';
import './assets/css/main.css';

/* Add the desired Font-Awesome fonts to the library for later use */
library.add(faSearch, faExternalLinkAlt, faSync, faInfoCircle, faSpinner, faQuestionCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
// Setup Google Analytics
Vue.use(VueGtag, {
  config: {
    id: 'UA-5217491-29',
    // Prevent parent-domain cookies (e.g., .vt.edu) to avoid cookie bloat / 431s across apps.
    // See: https://developers.google.com/analytics/devguides/collection/ga4/reference/config#cookie_domain
    params: {
      cookie_domain: 'none',
    },
  },
  appName: 'Group Manager',
  pageTrackerEnabled: true,
}, router);
Vue.mixin(titleMixin);

Vue.config.productionTip = false;

// Default vue-cookies config:
// config(expireTime, path, domain, secure, sameSite)
//    expireTime == 0 - Sets expiration to Session
Vue.$cookies.config('0', '', '', true, 'Strict');

// eslint-disable-next-line
export const eventBus = new Vue({
  data: {
    appStatus: {
      statusCode: 0,
      statusMessage: '',
    },
  },
  methods: {
    displayStatus() {
      eventBus.$emit('statusShouldBeDisplayed');
    },
    clearStatus() {
      this.appStatus.statusCode = 0;
      this.appStatus.statusMessage = '';
      eventBus.$emit('statusIsCleared');
    },
    clearPersonMembers() {
      eventBus.$emit('clearPersonMembers');
    },
  },
});

// Do initial configuration load before the Vue instance is created.
/* eslint-disable no-new */
store.dispatch('fetchConfigData').finally(() => {
  new Vue({
    /* Inject Vuex store into all children */
    store,
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
  });
});




// WEBPACK FOOTER //
// ./src/main.js